let selectorWithMediaQueryString = "";

export function handleStyleUpdate() {
  const editor = window.editor;
  const currentCss = editor.getCss({ keepUnusedStyles: true });
  const index = currentCss.indexOf(selectorWithMediaQueryString);

  const firstOpenBracePosition = currentCss.indexOf("{", index + 1);
  const secondOpenBracePosition = currentCss.indexOf("{", firstOpenBracePosition + 1);
  const firstClosedBracePosition = currentCss.indexOf("}", secondOpenBracePosition + 1);
  const newCss = currentCss.slice(0, firstClosedBracePosition + 1) + "}" + currentCss.slice(firstClosedBracePosition + 1, currentCss.length);

  editor.UndoManager.skip(() => {
    editor.setStyle(newCss);
    const selectorFromMediaQueryString = selectorWithMediaQueryString.slice(selectorWithMediaQueryString.indexOf("{") + 1).trim();
    editorStyleSelectSelectorForCurrentDevice(editor, selectorFromMediaQueryString);
  });
}

export const editorStyleSelectSelectorForCurrentDevice = (editor, selector) => {
  editor.off("component:styleUpdate", handleStyleUpdate);

  const currentDevice = editor.DeviceManager.getSelected();

  if (currentDevice.id === "Default") {
    editor.StyleManager.select(selector);
    return;
  }
  const currentDeviceMediaQuery = `(max-width: ${currentDevice.attributes.widthMedia})`;
  console.log(currentDeviceMediaQuery);

  const mediaQueryObj = {
    atRuleType: "media",
    atRuleParams: currentDeviceMediaQuery,
  };

  const existingCSSRuleForCurrentDevice = editor.CssComposer.getRule(selector, mediaQueryObj);

  if (existingCSSRuleForCurrentDevice) {
    editor.StyleManager.select(existingCSSRuleForCurrentDevice);
    return;
  }

  selectorWithMediaQueryString = `@media ${currentDeviceMediaQuery} { ${selector}`;

  editor.StyleManager.select(selectorWithMediaQueryString);

  editor.once("component:styleUpdate", handleStyleUpdate);
};